import React, { useEffect, useState } from "react";
import {
  Input,
  Typography,
  Button,
  Select, Option, Checkbox
} from "@material-tailwind/react";
import axios from "axios";
import swal from "sweetalert";
import { useDispatch, useSelector } from "react-redux";
import { API_BASE_URL } from "../../../data/static-config";
import { setLoaderVisibility } from "../../../app/actions/action-creators";
import { idLabelMitra, enLabelMitra } from "../../../data/static-config";

export function ModalForm({ callback, navUrl, id, title }) {
  const [label, setLabel] = useState("");
  const [findingInput, setFindingInput] = useState();
  const [orgInput, setOrgInput] = useState();
  const [emailInput, setEmailInput] = useState();
  const [locationInput, setLocationInput] = useState();
  const [file, setFile] = useState();
  const [stateInput, setStateInput] = useState();
  const [isReleaseInput, setIsReleaseInput] = useState(false);
  const [language, setLanguage] = useState(1033);
  const [imgPreview, setImgPreview] = useState();
  const token = useSelector((state) => state?.combineReducer?.adminToken?.token);
  const findingStatuses = useSelector((state) => state?.combineReducer?.adminOrganizations?.findingPartners?.data?.partnerListTabs);
  const dispatch = useDispatch();
  const languageCode = useSelector((state) => state?.combineReducer?.clientLanguage?.data);
  const [lblLanguage, setLblLanguage] = useState();

  useEffect(() => {
    languageCode == 1033 ? setLblLanguage(enLabelMitra) : setLblLanguage(idLabelMitra);
  }, [languageCode]);

  useEffect(() => {
    setLabel(title);
    dispatch(setLoaderVisibility(true));
    try {
      axios
        .get(`${API_BASE_URL}/api/partner/${id}`, {
          headers: {
            access_token: token
          }
        })
        .then(({ data }) => {
          dispatch(setLoaderVisibility(false));
          setFindingInput(data?.data?.finding);
          setOrgInput(data?.data?.organization);
          setEmailInput(data?.data?.email);
          setLocationInput(data?.data?.located);
          setLanguage(data?.data?.languageCode);
          setStateInput(data?.data?.statusCode);
          setImgPreview(data?.data?.imgUrl);
        })
        .catch((e) => {
          console.log(e);
          dispatch(setLoaderVisibility(false));
        })
    } catch (error) {
      console.log(error);
    }
  }, []);

  const handleUpload = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(setLoaderVisibility(true));
    const reqParams = new FormData()
    reqParams.append("finding", findingInput);
    reqParams.append("organization", orgInput);
    reqParams.append("located", locationInput);
    reqParams.append("publishStatus", isReleaseInput);
    reqParams.append("languageCode", language);
    reqParams.append("statusCode", stateInput);
    reqParams.append("email", emailInput);
    reqParams.append("file", file);

    try {
      if (id) {
        axios
          .put(`${API_BASE_URL}/api/partner/${id}`, reqParams, {
            headers: {
              access_token: token
            }
          })
          .then(({ data }) => {
            const res = {
              lst: data.data,
              link: navUrl
            }
              / dispatch(setLoaderVisibility(false));
            swal("Data Updated", "", "success").then((_) => {
              callback();
            });
          })
          .catch((e) => {
            console.log(e);
            dispatch(setLoaderVisibility(false));
          })
      } else {
        axios
          .post(`${API_BASE_URL}/api/partner`, reqParams, {
            headers: {
              access_token: token
            }
          })
          .then(({ data }) => {
            const res = {
              lst: data.data,
              link: navUrl
            }
            dispatch(setLoaderVisibility(false));
            swal("Data created", "", "success").then((_) => {
              callback();
            });
          })
          .catch((e) => {
            console.log(e);
            dispatch(setLoaderVisibility(false));
          })
      }
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <>
      <div className="flex justify-center items-center overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-auto my-6 mx-auto max-w-3xl">
          <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
            <div className="flex items-start justify-between p-5 border-b border-solid border-gray-300 rounded-t ">
              <Typography variant="h5">
                {label}
              </Typography>
            </div>
            <form onSubmit={(e) => handleSubmit(e)}>
              <div className="relative p-2 flex-auto">
                <div className="shadow-md rounded px-8 pt-6 pb-8 w-full flex flex-col gap-4">
                  <Input label={lblLanguage?.form?.finding} className="shadow appearance-none border rounded w-full py-2 px-1 text-black" value={findingInput} onChange={(e) => setFindingInput(e.target.value)} required />
                  <Input label={lblLanguage?.form?.org} className="shadow appearance-none border rounded w-full py-2 px-1 text-black" value={orgInput} onChange={(e) => setOrgInput(e.target.value)} required />
                  <div className="flex gap-2">
                    <Input label={lblLanguage?.form?.location} className="shadow appearance-none border rounded w-full py-2 px-1 text-black" value={locationInput} onChange={(e) => setLocationInput(e.target.value)} required />
                    <Input label={lblLanguage?.form?.email} type="email" className="shadow appearance-none border rounded w-full py-2 px-1 text-black" value={emailInput} onChange={(e) => setEmailInput(e.target.value)} required />
                  </div>
                  <div className="flex gap-2">
                    <Select label={lblLanguage?.form?.state} defaultValue={0} value={stateInput} onChange={(e) => setStateInput(e)}>
                      {
                        findingStatuses?.map(({name, value, id}, index) => (
                          <Option key={id} value={value}>{name}</Option>
                        ))
                      }
                    </Select>
                    {/* <Select value={language} onChange={(e) => setLanguage(e)} defaultValue={language} label="Language">
                      <Option value={1033} aria-label="English">English</Option>
                      <Option value={1045} aria-label="Bahasa Indonesia">Bahasa Indonesia</Option>
                    </Select> */}
                  </div>
                  <Input label={lblLanguage?.form?.upload} type="file" className="shadow appearance-none border rounded w-full py-2 px-1 text-black" onChange={handleUpload} />
                </div>
              </div>
              <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
                <button
                  className="text-red-500 background-transparent font-bold uppercase px-4 py-2 text-sm outline-none focus:outline-none mr-1 mb-1"
                  type="button"
                  onClick={callback}
                >
                  Close
                </button>
                <Button
                  className="text-white bg-green-900 active:bg-green-700 font-bold uppercase text-sm px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1"
                  type="submit"
                >
                  Submit
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}